import { createFileRoute, Link, useNavigate } from '@tanstack/react-router';
import type { CreateBillInput } from '@accounting/shared';
import { useCreateBill } from '../../hooks/useBills';
import { useActiveCompanyId } from '../../stores/useCompanyStore';
import { BillForm } from '../../components/bills/BillForm';
import { ApiError } from '../../lib/api';

export const Route = createFileRoute('/_auth/bills/new')({
  component: NewBillPage,
});

function NewBillPage() {
  const companyId = useActiveCompanyId();
  const navigate = useNavigate();
  const create = useCreateBill(companyId);

  if (!companyId) {
    return (
      <div className="card" style={{ textAlign: 'center', padding: 32 }}>
        <p className="muted">No active company.</p>
        <Link to="/companies" className="btn-primary" style={{ display: 'inline-block', textDecoration: 'none' }}>
          Go to Companies
        </Link>
      </div>
    );
  }

  const errorMessage =
    create.error instanceof ApiError
      ? (create.error.body as { error?: string } | null)?.error ?? 'Could not create bill'
      : create.error?.message;

  return (
    <div>
      <Link to="/bills" style={{ fontSize: 13 }}>← Bills</Link>
      <h1 style={{ fontSize: 24, margin: '8px 0 16px' }}>New bill</h1>

      <BillForm
        companyId={companyId}
        submitLabel="Save & enter bill"
        submitting={create.isPending}
        errorMessage={errorMessage}
        cancelTo="/bills"
        onSubmit={(input) =>
          create.mutate(input as CreateBillInput, {
            onSuccess: (bill) => void navigate({ to: '/bills/$id', params: { id: bill.id } }),
          })
        }
      />
    </div>
  );
}
